export default __webpack_public_path__ + "static/media/jap-ecommerceImg_1.ec1e6475.webp";